import styled from "styled-components";

export const StyledRadio = styled.label`
  display: inline-flex !important;
  position: relative;
  padding-left: 30px;
  margin-bottom: 6px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  line-height: 22px;
  height: 22px;
  align-items: center;

  .text {
    ${({ theme }) => theme.fontStyles.InterfaceCopy}
    color: ${({ theme }) => theme.colors.neutralsTextLight};
  }

  &:hover .text {
    color: ${({ theme }) => theme.colors.primaryTextHover};
  }

  input:checked ~ .text {
    color: ${({ theme }) => theme.colors.neutralsText};
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 22px;
    width: 22px;
    background-color: ${({ theme }) => theme.colors.neutralsWhiteTint60};
    border: 1px solid ${({ theme }) => theme.colors.primarySeparator};
    border-radius: 50%;
  }

  &:hover input:not(:disabled) ~ .checkmark {
    border-color: ${({ theme }) => theme.colors.primaryTextHover};
    box-shadow: 0 0 5px 0px ${({ theme }) => theme.colors.primaryTextHover};

    &:after {
      display: block;
      background-color: ${({ theme }) => theme.colors.primarySeparator};
    }
  }

  &:hover input:checked ~ .checkmark:after {
    background-color: ${({ theme }) => theme.colors.primaryBackgroundSelected};
  }

  input:checked ~ .checkmark {
    background: ${({ theme }) => theme.colors.neutralsWhite};
    border-color: ${({ theme }) => theme.colors.primaryBackgroundSelected};
  }

  input:disabled:not(:checked) ~ .checkmark {
    background: ${({ theme }) => theme.colors.disabledInputBackground};
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  input:checked ~ .checkmark:after {
    display: block;
  }

  .checkmark:after {
    top: 50%;
    left: 50%;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.primaryBackgroundSelected};
    transform: translate(-50%, -50%);
  }
`;
